const defaultLayout = [
  '1 2 3 4 5 6 7 8 9 0 {bksp}',
  'a z e r t y u i o p',
  'q s d f g h j k l m',
  '{shift} w x c v b n {enter}',
  '{space}',
]
const shiftLayout = [
  '1 2 3 4 5 6 7 8 9 0 {bksp}',
  'A Z E R T Y U I O P',
  'Q S D F G H J K L M',
  '{shift} W X C V B N {enter}',
  '{space}',
]
const display = {
  '{bksp}': '⌫',
  '{enter}': '⏎',
  '{shift}': '⇧',
  '{reverse}': '⇩',
  '{space}': ' ',
}

export { defaultLayout, shiftLayout, display }
